let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("iH1oz")).then(() => parcelRequire('lti6p'));